const apiStatus = [
    { label: '审核中', value: '1' },
    { label: '审核通过', value: '2' },
    // { label: '已过期', value: '3' },
    { label: '驳回', value: '3' }
];
const apiType = [
    { label: '推送', value: 0 },
    { label: 'Api', value: 1 }
];

export default {
    install(Vue) {
        Vue.$constants = Vue.prototype.$constants = {
            apiStatus,
            apiType
        };
    },
};

export {
    apiStatus,
    apiType
};



// WEBPACK FOOTER //
// ./src/assets/js/constants.js